export default "__VITE_ASSET__5f41d594__"